<template>
  <div class="vx-card" v-if="loaded">
    <div class="vx-card__body card-body">
      <form>
        <div class="vx-row mb-6">
          <div class="vx-col lg:w-1/3 sm:w-1/3 w-full">
            <vs-input
              class="inputx mt-1"
              v-model="model.username"
              :label="$t('UserName')"
              readonly="readonly"
            />
          </div>
          <div class="vx-col lg:w-1/3 sm:w-1/3 w-full">
            <vs-input
              class="inputx mt-1"
              v-model="model.name"
              name="fullname"
              v-validate="'required'"
              :label="$t('FullName')"
            />
            <span class="text-danger text-sm" v-show="errors.has('fullname')">{{
              errors.first("fullname")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/3 sm:w-1/3 w-full">
            <vs-input
              class="inputx mt-1"
              v-model="model.email"
              name="email"
              v-validate="'required'"
              :label="$t('Email')"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col  w-full">
            <vs-button
              type="filled"
              class="float-right"
              @click.prevent="submitForm()"
              :disabled="disabled"
              >{{ $t("Submit") }}</vs-button
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";
import axios from "axios";
import authService from "../../auth/authService";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
const dict = {
  custom: {
    fullname: {
      required: "لطفا نام و نام خانوادگی خود را وارد نمایید."
    },
    email: {
      required: "لطفا پست الکترونیک خود را وارد نمایید."
    }
  }
};
Validator.localize("fa", dict);
export default {
  data() {
    return {
      loaded: false,
      model: {
        username: "",
        isEmailConfirmed: true,
        email: "",
        phoneNumber: "",
        statusMessage: "",
        name: "",
        website: "",
        profile: "",
        streetAddress: "",
        locality: "",
        region: "",
        postalCode: "",
        country: ""
      },
      disabled: false
    };
  },
  async mounted() {
    var userInfo = await authService.getUser();
    var userID = userInfo.profile.sub;
    axios
      .get(
        "https://userapi.avajang.com/api/Users/user/" + userID + "/claims",
        this.model
      )
      .then(r => {
        this.model = r.data;
        this.loaded = true;
      })
      .catch(e => {
        this.$swal({
          position: "center-center",
          type: "error",
          text: e.request.response,
          showConfirmButton: false,
          timer: 8000
        });
      });
  },
  methods: {
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.disabled = true;
          axios
            .post(
              "https://userapi.avajang.com/api/Users/user-claims",
              this.model
            )
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000
              });
              this.$validator.reset();
              this.disabled = false;
            })
            .catch(e => {
              this.$swal({
                position: "center-center",
                type: "error",
                text: e.request.response,
                showConfirmButton: false,
                timer: 8000
              });
              this.$validator.reset();
              this.disabled = false;
            });
        } else {
          // form have errors
        }
      });
    }
  }
};
</script>
